<template>
  <onboard-main action="profile" :previous-details="previousDetails" :resume-url="resumeUrl" :avatar-url="avatarUrl" />
</template>

<script setup>
import OnboardMain from '@/components/Onboarding/OnboardMain.vue';
import { alert, errorMessage } from '@/utils/helper';
import { onBeforeMount, ref } from 'vue';
import { useStore } from 'vuex';

const store = useStore();
const previousDetails = ref({});
const resumeUrl = ref(null);
const avatarUrl = ref(null);

const transformExperiences = (experiences) => {
  return experiences.map((item) => {
    return {
      position_name: item?.title || item?.position_name,
      company_name: item.company_name,
      country: item?.country || item.company_location,
      start_date: item?.started_at || item?.start_date,
      end_date: item?.ended_at || item.end_date,
      job_details: item?.description || item?.job_details,
    };
  });
};

const transformQual = (qualifications) => {
  return qualifications.map((item) => {
    return {
      ...item,
      faculty_department: '',
      specialization_subjects: '',
    };
  });
};

onBeforeMount(async () => {
  try {
    const { data } = await store.dispatch('auth/getUser', { forceReload: true });
    const { name, candidate } = data;
    resumeUrl.value = candidate?.resume;
    avatarUrl.value = candidate?.avatar;

    const {
      educations,
      projects,
      experiences,
      job_preference,
      role_title,
      skills,
      years_of_experience,
      professional_title_uuid,
      phone_number,
      social_links,
      address,
    } = candidate;
    const { company_categories, availability_status, desired_salary, desired_salary_currency, job_types, work_type, next_role_perks } =
      job_preference;
    const { city, state, country, timezone } = address;

    const socials = {};
    social_links.map((item) => {
      socials[item.platform] = item.url;
    });

    const defaultSocials = {
      linkedin: '',
      github: '',
      dribbble: '',
      stackoverflow: '',
      behance: '',
      glassdoor: '',
      website: '',
    };

    previousDetails.value = {
      candidate_name: name,
      candidate_phone: phone_number,
      education_qualifications: educations ? transformQual(educations) : [],
      positions: experiences ? transformExperiences(experiences) : [],
      projects: projects || [],
      role_title: role_title || '',
      company_categories: company_categories || [],
      availability_status: availability_status || '',
      desired_salary: desired_salary || '',
      desired_salary_currency: desired_salary_currency || '',
      job_types: job_types || [],
      work_type: work_type || [],
      next_role_perks: next_role_perks || [],
      years_of_experience: years_of_experience || '',
      skills: skills || [],
      professional_title: professional_title_uuid,
      social_links: { ...defaultSocials, ...socials },
      city: city || '',
      state: state || '',
      country: country || '',
      timezone: timezone || '',
    };
  } catch (error) {
    alert(errorMessage(error));
  }
});
</script>
